import { render } from "./ErrorDetailsPopup.vue?vue&type=template&id=0a58b030&scoped=true"
import script from "./ErrorDetailsPopup.vue?vue&type=script&lang=js"
export * from "./ErrorDetailsPopup.vue?vue&type=script&lang=js"

import "./ErrorDetailsPopup.vue?vue&type=style&index=0&id=0a58b030&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a58b030"]])

export default __exports__